<template lang="pug">
	.sections-changes-history(v-if="showed")
		.modal(:tabindex="-1" :role="'dialog'" :style="{'display': 'block'}")
			.modal-dialog.modal-dialog-centered(:role ="'document'")
				.modal-content
					.modal-header
						h5.modal-title Sections changes history
						.section-filter
							h6.section-filter-text Section
							select.custom-select.custom-select-sm(v-model="selectedSection")
								option(:value="'all'") All
								option(v-for="title in sectionsList" :value="title") {{title}}

					.modal-body
						.modal-loading(v-if="!received")
							.icon.fa.fa-spinner.fa-spin
						.modal-loaded(v-else)
							table.table.changes-table(v-if="changes.length > 0")
								thead
									tr
										th(scope="col") Section
										th(scope="col") Property
										th(scope="col") New value
										th(scope="col") Previous value
										th(scope="col") User
										//th(scope="col") User
										th(scope="col") Timestamp
										th(scope="col")
								tbody
									tr(v-for="change in currentChanges")
										td {{change.sectionTitle}}
										td {{change.property.replace('Data.', '')}}
										td {{change.new_value}}
										td {{change.previous_value}}
										td.user-td(data-toggle="tooltip" data-placement="top" :title="User.Users[change.user_id].name")
											img.user-avatar(:src="User.Users[change.user_id].photo" referrerpolicy="no-referrer")
											div.user-name {{User.Users[change.user_id].name.split(' ')[0] + ' ' + User.Users[change.user_id].name.split(' ')[1][0] + '.'}}
										td.timestamp {{change.timestampFormatted}}
										td
											button.btn.btn-secondary(type="button" v-on:click="undoChange(change)") Undo
							.no-history(v-else)
								div There is no change history for this project


					.modal-footer
						//button.btn.btn-primary(type="button" v-on:click="save") Save
						button.btn.btn-dark(type="button" v-on:click="close") Close

</template>
<script>
import Screen 				from './../../mixins/screen';
import { User }				from './../../services/User'

export default {
	name: 'SectionsChangesHistory',
	mixins: [Screen],
	screen: {
		events: {
			"Project Sections Changes Received": function (changes) {

				this.received = true;
				this.changes = changes;
				this.sectionsList = changes.reduce((a, b) => a.add(b.sectionTitle), new Set());
				this.currentChanges = changes;

			}
		},
		updateOn: [],
		showed: false,
		received: false
	},
	data() {
		this.User = User;
		return {
			newIPs: '',
			received: false,
			selectedSection: 'all',
			sectionsList: new Set()
		}
	},
	watch: {
		selectedSection: function (val, oldVal) {
			if (val === 'all') this.currentChanges = this.changes;
			else this.currentChanges = this.changes.filter(change => change.sectionTitle === val);
		}
	},
	methods: {
		collectData() {
			if (!this.showed) return;
			this.received = false;
			Server.sendToSocket({
				GetProjectSectionsChanges: {
					projectId: Project.SelectedProject.id
				}
			});
		},
		close() {
			this.hide();
		},
		save() {

			Server.sendToSocket({
				AirbrakerUpdatedFitlteredIPs: {
					IPs: this.newIPs.split('\n')
				}
			});
			this.close();
		},
		undoChange(change) {
			let property = change.property;
			let propertyType = change.property;
			if (property.startsWith('Data.styles.')) {
				propertyType = 'style';
				property = property.replace('Data.styles.', '');
				Section.saveSectionStyle_(Section.Sections[change.section_id], property, change.previous_value);
			} else if (property.startsWith('Data.')) {
				propertyType = 'data';
				property = property.replace('Data.', '')
				Section.saveSectionData(Section.Sections[change.section_id], property, change.previous_value);
			} else if (property === 'type') {
				propertyType = 'type';
				property = 'type';
				Section.saveSectionType(Section.Sections[change.section_id], change.previous_value);
			}
			console.log(change);

			Server.sendToSocket({
				GetProjectSectionsChanges: {
					projectId: Project.SelectedProject.id
				}
			});
		}
	}

}
</script>
<style lang="sass">

.sections-changes-history
	position: absolute
	z-index: 2000
	left: 0
	top: 0
	right: 0
	bottom: 0
	background-color: rgba(0, 0, 0, 0.6)

	.modal-dialog
		max-width: 60%

	.modal-content
		border: none
		background: none

		.modal-header
			background-color: #343b41
			border-bottom: 1px solid #23282c
			color: #e4e7ea

			.section-filter
				display: flex
				flex-direction: row
				align-items: baseline

				select
					margin-left: 10px
					border: 1px solid #23282c
					background-color: #515b65
					color: whitesmoke

		.modal-body
			background-color: #3a4149

			.modal-loading
				display: flex
				width: 100%
				align-items: center
				flex-direction: column
				justify-content: center

				.fa-spin
					font-size: 50px
					color: #e4e7ea

			.modal-loaded

				max-height: 500px
				overflow-y: auto
				border-bottom: 1px solid rgba(255, 255, 255, 0.1)

				.changes-table
					color: white

					thead > tr > th
						background-color: #3a4149
						border: 1px solid hsla(0,0%,100%,.1)

					tr > td
						border-color: hsla(0,0%,100%,.1)

					tr > td.timestamp
							white-space: nowrap

					tr > td.user-td
						display: flex
						flex-direction: row
						vertical-align: baseline

						.user-avatar
							height: 1.5em
							border-radius: 1.5em
							margin-right: 5px
						.user-name
							white-space: nowrap

					tr > td > button
						color: #ffffff
						background-color: #515b65
						border-color: #c8ced3

					tr:nth-child(odd)
						background-color: #00000030

					.change-row
						display: flex
						flex-direction: row

				.no-history
					display: flex
					color: white

					div
						color: white
						margin: auto
						font-size: 2rem

			.modal-loaded::-webkit-scrollbar
				width: 5px
				height: 8px
				background-color: #31363c

			.modal-loaded::-webkit-scrollbar-thumb
				background-color: #454c54

		.modal-footer
			background-color: #3a4149
			border: none
			justify-content: end


</style>
